export default __webpack_public_path__ + "static/media/gold-divider-top.a2627002.svg";